import React, { useEffect, useState, Component } from 'react';
import { Clock, ShieldCheck, AlertTriangle, ChevronDown, Star } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function Pricing() {
  const [timeLeft, setTimeLeft] = useState({
    h: 23,
    m: 59,
    s: 40
  });
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const [selectedPlan, setSelectedPlan] = useState<'pro' | 'basic'>('pro');
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.s > 0) return {
          ...prev,
          s: prev.s - 1
        };
        if (prev.m > 0) return {
          ...prev,
          m: prev.m - 1,
          s: 59
        };
        if (prev.h > 0) return {
          h: prev.h - 1,
          m: 59,
          s: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (val: number) => val.toString().padStart(2, '0');
  const faqs = [{
    q: '¿Sirve si no sé nada de mecánica?',
    a: 'Sí. El Protocolo Anti-Tirado fue diseñado específicamente para personas sin conocimientos técnicos. Cada paso está explicado en lenguaje simple, con tablas claras y decisiones de sí/no. No necesitás saber mecánica para seguir los 15 pasos o usar el mapa de decisión.'
  }, {
    q: '¿Sirve para cualquier tipo de moto?',
    a: 'Sí. El sistema está optimizado para motos 110/150cc — las más vendidas en Argentina — pero los protocolos de emergencia aplican a cualquier moto de uso urbano o de ruta.'
  }, {
    q: '¿Cómo recibo el material?',
    a: '100% digital. En menos de 5 minutos después del pago recibís acceso a todos los PDFs en tu email. Los descargás, los guardás en el celular y están disponibles sin internet cuando los necesitás.'
  }, {
    q: '¿Qué lo diferencia del material gratuito de YouTube?',
    a: 'YouTube te da información suelta. El Protocolo Anti-Tirado te da un sistema de decisión ordenado para usar en el momento exacto de la emergencia — cuando estás solo, de noche, en la calle y con el corazón acelerado. No es lo mismo saber mecánica que tener un protocolo claro bajo presión.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días con devolución del 100% sin preguntas. Si no es lo que esperabas, escribís a soporteoficialfegion@gmail.com y en 24 horas tenés el reembolso.'
  }];
  return <section id="pricing" className="py-24 bg-surface border-t border-white/5 relative overflow-hidden" data-id="element-197">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[1000px] h-[500px] bg-cyan/5 rounded-full blur-[150px] pointer-events-none" data-id="element-198"></div>

      <div className="container mx-auto px-4 max-w-6xl relative z-10" data-id="element-199">
        {/* Countdown */}
        <FadeIn data-id="element-200">
          <div className="text-center mb-16" data-id="element-201">
            <h2 className="text-3xl md:text-4xl font-bold mb-8 text-white" data-id="element-202">
              ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
            </h2>

            <div className="flex justify-center gap-4 mb-6" data-id="element-203">
              <div className="bg-background border border-cyan/30 w-20 h-24 md:w-24 md:h-28 rounded-xl flex flex-col items-center justify-center shadow-[0_0_15px_rgba(0,229,255,0.1)]" data-id="element-204">
                <span className="text-4xl md:text-5xl font-bold text-cyan font-heading" data-id="element-205">
                  {formatTime(timeLeft.h)}
                </span>
                <span className="text-xs text-gray-400 uppercase mt-2" data-id="element-206">
                  Horas
                </span>
              </div>
              <div className="text-4xl md:text-5xl font-bold text-cyan/50 self-center pb-6" data-id="element-207">
                :
              </div>
              <div className="bg-background border border-cyan/30 w-20 h-24 md:w-24 md:h-28 rounded-xl flex flex-col items-center justify-center shadow-[0_0_15px_rgba(0,229,255,0.1)]" data-id="element-208">
                <span className="text-4xl md:text-5xl font-bold text-cyan font-heading" data-id="element-209">
                  {formatTime(timeLeft.m)}
                </span>
                <span className="text-xs text-gray-400 uppercase mt-2" data-id="element-210">
                  Min
                </span>
              </div>
              <div className="text-4xl md:text-5xl font-bold text-cyan/50 self-center pb-6" data-id="element-211">
                :
              </div>
              <div className="bg-background border border-cyan/30 w-20 h-24 md:w-24 md:h-28 rounded-xl flex flex-col items-center justify-center shadow-[0_0_15px_rgba(0,229,255,0.1)]" data-id="element-212">
                <span className="text-4xl md:text-5xl font-bold text-cyan font-heading" data-id="element-213">
                  {formatTime(timeLeft.s)}
                </span>
                <span className="text-xs text-gray-400 uppercase mt-2" data-id="element-214">
                  Seg
                </span>
              </div>
            </div>

            <div className="inline-flex items-center gap-2 text-yellow bg-yellow/10 px-4 py-2 rounded-full text-sm font-medium mb-6" data-id="element-215">
              <AlertTriangle className="w-4 h-4" data-id="element-216" />
              ⚠️ Después sube $8.000 ARS. No vuelve.
            </div>

            {/* Scarcity Bar */}
            <div className="max-w-md mx-auto bg-surfaceLight/50 rounded-xl p-4 border border-red-500/20" data-id="element-217">
              <div className="flex items-center justify-between mb-2" data-id="element-218">
                <span className="text-red-400 font-bold text-sm flex items-center gap-2" data-id="element-219">
                  <span className="relative flex h-2 w-2" data-id="element-220">
                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75" data-id="element-221"></span>
                    <span className="relative inline-flex rounded-full h-2 w-2 bg-red-500" data-id="element-222"></span>
                  </span>
                  🔴 Quedan pocos cupos al precio de lanzamiento
                </span>
              </div>
              <div className="w-full bg-background rounded-full h-2.5 mb-2 overflow-hidden border border-white/5" data-id="element-223">
                <div className="bg-gradient-to-r from-red-500 to-red-400 h-2.5 rounded-full" style={{
                width: '68%'
              }} data-id="element-224"></div>
              </div>
              <p className="text-xs text-gray-400 text-right" data-id="element-225">
                68% de los cupos ya tomados
              </p>
            </div>
          </div>
        </FadeIn>

        {/* Pricing Selector */}
        <FadeIn delay={0.1} data-id="element-226">
          <h2 className="text-3xl md:text-4xl font-bold text-white text-center mb-10" data-id="element-227">
            ELEGÍ TU <span className="text-cyan" data-id="element-228">MEGA PACK</span>
          </h2>
        </FadeIn>

        <div id="elegir-plan" className="max-w-2xl mx-auto mb-24" data-id="element-229">
          {/* Basic Plan Option */}
          <FadeIn delay={0.1} data-id="element-230">
            <button onClick={() => setSelectedPlan('basic')} className={`w-full text-left rounded-2xl p-6 mb-4 transition-all duration-300 border-2 ${selectedPlan === 'basic' ? 'border-cyan shadow-[0_0_25px_rgba(0,229,255,0.15)] bg-surfaceLight/60' : 'border-white/10 bg-background hover:border-white/20'}`} data-id="element-231">
              <div className="flex items-start gap-4" data-id="element-232">
                {/* Radio */}
                <div className={`mt-1 w-5 h-5 rounded-full border-2 flex items-center justify-center shrink-0 transition-colors ${selectedPlan === 'basic' ? 'border-cyan' : 'border-gray-500'}`} data-id="element-233">
                  {selectedPlan === 'basic' && <div className="w-2.5 h-2.5 rounded-full bg-cyan" data-id="element-234"></div>}
                </div>

                {/* Content */}
                <div className="flex-1 min-w-0" data-id="element-235">
                  <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4" data-id="element-236">
                    <div data-id="element-237">
                      <h3 className="text-xl font-bold text-white flex items-center gap-2 mb-1" data-id="element-238">
                        <span data-id="element-239">📘</span> MEGA PACK MOTOCICLISTA
                      </h3>
                      <p className="text-gray-400 text-sm mb-3" data-id="element-240">
                        6 Módulos + 5 Bonos
                      </p>
                      <div className="bg-surfaceLight/50 px-3 py-2 rounded-lg border border-white/5 text-xs text-gray-300 inline-block" data-id="element-241">
                        <span className="font-semibold text-white" data-id="element-242">
                          Ideal para:
                        </span>{' '}
                        Motociclistas que quieren rodar seguros y preparados
                      </div>
                    </div>
                    <div className="sm:text-right shrink-0" data-id="element-243">
                      <span className="text-gray-500 line-through text-sm block" data-id="element-244">
                        $51.000
                      </span>
                      <span className="text-3xl font-bold text-white font-heading" data-id="element-245">
                        $19.990
                      </span>
                      <span className="text-sm text-gray-400 ml-1" data-id="element-246">ARS</span>
                    </div>
                  </div>
                </div>
              </div>
            </button>
          </FadeIn>

          {/* Pro Plan Option */}
          <FadeIn delay={0.2} data-id="element-247">
            <div className="relative" data-id="element-248">
              <div className="absolute -top-3 left-1/2 -translate-x-1/2 z-10" data-id="element-249">
                <span className="bg-cyan text-background font-bold px-4 py-1 rounded-full text-xs uppercase tracking-wider" data-id="element-250">
                  Más Elegido ⭐
                </span>
              </div>
              <button onClick={() => setSelectedPlan('pro')} className={`w-full text-left rounded-2xl p-6 transition-all duration-300 border-2 ${selectedPlan === 'pro' ? 'border-cyan shadow-[0_0_25px_rgba(0,229,255,0.15)] bg-surfaceLight/60' : 'border-white/10 bg-background hover:border-white/20'}`} data-id="element-251">
                <div className="flex items-start gap-4" data-id="element-252">
                  {/* Radio */}
                  <div className={`mt-1 w-5 h-5 rounded-full border-2 flex items-center justify-center shrink-0 transition-colors ${selectedPlan === 'pro' ? 'border-cyan' : 'border-gray-500'}`} data-id="element-253">
                    {selectedPlan === 'pro' && <div className="w-2.5 h-2.5 rounded-full bg-cyan" data-id="element-254"></div>}
                  </div>

                  {/* Content */}
                  <div className="flex-1 min-w-0" data-id="element-255">
                    <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4" data-id="element-256">
                      <div data-id="element-257">
                        <h3 className="text-xl font-bold text-white flex items-center gap-2 mb-1" data-id="element-258">
                          <span data-id="element-259">🏆</span> MEGA PACK + PROTOCOLO ANTI-TIRADO{' '}
                          <span className="text-yellow" data-id="element-260">⭐</span>
                        </h3>
                        <p className="text-cyan text-sm font-medium mb-3" data-id="element-261">
                          6 Módulos + 5 Bonos + Sistema Completo
                          Anti-Emergencias
                        </p>
                        <div className="bg-cyan/5 px-3 py-2 rounded-lg border border-cyan/20 text-xs text-gray-300 inline-block" data-id="element-262">
                          <span className="font-semibold text-white" data-id="element-263">
                            Ideal para:
                          </span>{' '}
                          Motociclistas que además quieren saber exactamente qué
                          hacer cuando la moto falla en la calle — de noche, en
                          ruta, solos
                        </div>
                      </div>
                      <div className="sm:text-right shrink-0" data-id="element-264">
                        <span className="text-gray-500 line-through text-sm block" data-id="element-265">
                          $69.000
                        </span>
                        <span className="text-3xl font-bold text-cyan font-heading" data-id="element-266">
                          $29.990
                        </span>
                        <span className="text-sm text-cyan/70 ml-1" data-id="element-267">ARS</span>
                      </div>
                    </div>
                  </div>
                </div>
              </button>
            </div>
          </FadeIn>

          {/* Single CTA Button */}
          <FadeIn delay={0.3} data-id="element-268">
            <a href={selectedPlan === 'pro' ? 'https://fegion.shop/cart/46672487350411:1' : 'https://fegion.shop/cart/46537414901899:1'} className="block w-full mt-6 py-5 text-center rounded-2xl font-bold text-background bg-cyan hover:bg-cyan/90 transition-all animate-pulse-glow shadow-lg uppercase tracking-wider text-lg" data-id="element-269">
              {selectedPlan === 'pro' ? '→ QUIERO EL MEGA PACK + PROTOCOLO ANTI-TIRADO' : '→ QUIERO MI MEGA PACK'}
            </a>
          </FadeIn>
        </div>

        {/* Pricing Cards */}
        <FadeIn delay={0.1} data-id="element-270"></FadeIn>

        {/* Moto Taller Pro Comparison Table */}
        <FadeIn delay={0.2} data-id="element-271">
          <div className="max-w-4xl mx-auto mb-16" data-id="element-272">
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-2 text-center" data-id="element-273">
              🔧 ¿QUÉ AGREGA EL PROTOCOLO ANTI-TIRADO?
            </h3>
            <p className="text-gray-400 text-center mb-6" data-id="element-274">
              El sistema completo para nunca más quedarte solo en la calle sin
              saber qué hacer
            </p>
            <p className="text-sm text-gray-400 mb-2 md:hidden text-center" data-id="element-275">
              ← Scroll to see full table →
            </p>
            <div className="overflow-x-auto pb-4" data-id="element-276">
              <table className="w-full min-w-[600px] text-left border-collapse" data-id="element-277">
                <thead data-id="element-278">
                  <tr data-id="element-279">
                    <th className="p-4 border-b border-white/10 text-gray-300 font-semibold bg-surfaceLight/30 rounded-tl-xl" data-id="element-280">
                      Situación
                    </th>
                    <th className="p-4 border-b border-white/10 text-red-400 font-semibold bg-red-500/5" data-id="element-281">
                      ❌ Sin Protocolo Anti-Tirado
                    </th>
                    <th className="p-4 border-b border-white/10 text-cyan font-semibold bg-cyan/5 rounded-tr-xl" data-id="element-282">
                      ✅ Con Protocolo Anti-Tirado
                    </th>
                  </tr>
                </thead>
                <tbody className="text-sm md:text-base" data-id="element-283">
                  <tr className="border-b border-white/5 hover:bg-white/5 transition-colors" data-id="element-284">
                    <td className="p-4 text-gray-300" data-id="element-285">
                      Tu moto se apaga sola en la calle a las 10 de la noche
                    </td>
                    <td className="p-4 text-gray-400 bg-red-500/5" data-id="element-286">
                      Pánico total. Llamás a alguien sin saber qué decirle.
                      Esperás la grúa 2 horas.
                    </td>
                    <td className="p-4 text-white bg-cyan/5 font-medium" data-id="element-287">
                      Abrís el protocolo. 15 pasos. En 10 minutos sabés
                      exactamente qué tiene y qué hacer.
                    </td>
                  </tr>
                  <tr className="border-b border-white/5 hover:bg-white/5 transition-colors" data-id="element-288">
                    <td className="p-4 text-gray-300" data-id="element-289">
                      Te pinchás en ruta sin gomería cerca
                    </td>
                    <td className="p-4 text-gray-400 bg-red-500/5" data-id="element-290">
                      Caminás o esperás que pare alguien. Perdés el día.
                    </td>
                    <td className="p-4 text-white bg-cyan/5 font-medium" data-id="element-291">
                      Kit de parches tubeless en el bolso. Reparación en 8
                      minutos. Seguís viaje.
                    </td>
                  </tr>
                  <tr className="border-b border-white/5 hover:bg-white/5 transition-colors" data-id="element-292">
                    <td className="p-4 text-gray-300" data-id="element-293">
                      La cadena se cae a 50km de casa
                    </td>
                    <td className="p-4 text-gray-400 bg-red-500/5" data-id="element-294">
                      No sabés si tocarla. La dejás tirada. Llamás grúa.
                    </td>
                    <td className="p-4 text-white bg-cyan/5 font-medium" data-id="element-295">
                      Protocolo de cadena caída paso a paso. Volvés a ponerla y
                      llegás al taller más cercano.
                    </td>
                  </tr>
                  <tr className="border-b border-white/5 hover:bg-white/5 transition-colors" data-id="element-296">
                    <td className="p-4 text-gray-300" data-id="element-297">
                      Falla eléctrica total — sin luces ni arranque
                    </td>
                    <td className="p-4 text-gray-400 bg-red-500/5" data-id="element-298">
                      No sabés ni dónde buscar. Todo apagado.
                    </td>
                    <td className="p-4 text-white bg-cyan/5 font-medium" data-id="element-299">
                      Test de fusible en 2 minutos. Fusible de repuesto en el
                      kit. En 5 minutos tenés luz y arranque.
                    </td>
                  </tr>
                  <tr className="border-b border-white/5 hover:bg-white/5 transition-colors" data-id="element-300">
                    <td className="p-4 text-gray-300" data-id="element-301">
                      Llamás al mecánico sin saber qué decirle
                    </td>
                    <td className="p-4 text-gray-400 bg-red-500/5" data-id="element-302">
                      "Se apagó y no sé qué tiene." Te cobran diagnóstico caro.
                    </td>
                    <td className="p-4 text-white bg-cyan/5 font-medium" data-id="element-303">
                      Protocolo de comunicación técnica. Describís exactamente
                      la falla. Ahorrás $15.000–$20.000 ARS.
                    </td>
                  </tr>
                  <tr className="hover:bg-white/5 transition-colors" data-id="element-304">
                    <td className="p-4 text-gray-300 rounded-bl-xl" data-id="element-305">
                      Salís a rodar sin saber el estado real de la moto
                    </td>
                    <td className="p-4 text-gray-400 bg-red-500/5" data-id="element-306">
                      Confiás en que "debe estar bien".
                    </td>
                    <td className="p-4 text-white bg-cyan/5 font-medium rounded-br-xl" data-id="element-307">
                      Checklist semanal de 5 minutos. Sabés exactamente el
                      estado antes de salir.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </FadeIn>

        {/* Kit Includes */}
        <FadeIn delay={0.3} data-id="element-308">
          <div className="max-w-4xl mx-auto mb-20 bg-surfaceLight/30 rounded-3xl p-8 border border-white/5" data-id="element-309">
            <h3 className="text-2xl font-bold text-white mb-8 text-center" data-id="element-310">
              ✅ EL PROTOCOLO ANTI-TIRADO INCLUYE:
            </h3>
            <div className="grid md:grid-cols-2 gap-4" data-id="element-311">
              {['🛠️ Componente 1 — Protocolo de 15 Pasos: El manual exacto para los primeros 15 minutos de cualquier emergencia en calle', 'Los 15 pasos en orden para diagnosticar cualquier falla sin entrar en pánico', 'Las 10 fallas más comunes con síntoma + causa + solución inmediata', 'Protocolo de arranque por empuje paso a paso y Test de chispa en calle', '🎒 Componente 2 — Kit de Emergencia Mínimo: La lista exacta de lo que siempre tenés que llevar', '11 items que resuelven el 80% de las emergencias en calle', 'Referencia exacta de bujía y eslabón maestro por modelo', '🗺️ Componente 3 — Mapa de Decisión de Emergencia: Una sola hoja plastificable'].map((item, i) => <div key={i} className="flex items-start gap-3 bg-background/50 p-4 rounded-xl border border-white/5" data-id="element-312">
                  <span className="text-gray-300" data-id="element-313">{item}</span>
                </div>)}
            </div>
          </div>
        </FadeIn>

        {/* Testimonials */}
        <FadeIn delay={0.4} data-id="element-314">
          <div className="max-w-5xl mx-auto mb-24" data-id="element-315">
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-10 text-center" data-id="element-316">
              ❤️ MÁS MOTOCICLISTAS QUE YA LO TIENEN
            </h3>
            <div className="grid md:grid-cols-2 gap-6" data-id="element-317">
              {[{
              name: 'Cecilia R.',
              loc: '📍 Mendoza',
              plan: 'Mega Pack + Protocolo Anti-Tirado',
              text: 'El sistema de arranque me sacó del "algún día arranco el taller". En 30 días ya tenía mis primeros clientes.'
            }, {
              name: 'Roberto M.',
              loc: '📍 Buenos Aires',
              plan: 'Motociclista',
              text: 'Con los scripts para el mecánico, en 10 minutos supe exactamente qué decirle y cuánto debía costarme.'
            }, {
              name: 'Sofía C.',
              loc: '📍 La Plata',
              plan: 'Motociclista',
              text: 'Hice el diagnóstico en 3 minutos antes de salir y encontré algo que me hubiera dejado tirada en la ruta.'
            }, {
              name: 'Pablo A.',
              loc: '📍 Neuquén',
              plan: 'Motociclista',
              text: 'Me pinché de noche en la ruta 2 volviendo de Mar del Plata. Abrí el mapa de decisión, seguí los pasos y en 12 minutos estaba rodando de nuevo. Sin el protocolo, esa noche dormía en la banquina.'
            }].map((t, i) => <div key={i} className="bg-surfaceLight p-6 rounded-2xl border border-white/5" data-id="element-318">
                  <div className="flex gap-1 mb-3" data-id="element-319">
                    {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-yellow text-yellow" data-id="element-320" />)}
                  </div>
                  <p className="text-gray-300 mb-4 italic" data-id="element-321">"{t.text}"</p>
                  <div className="text-sm" data-id="element-322">
                    <span className="font-bold text-white" data-id="element-323">{t.name}</span>
                    <span className="text-gray-500 mx-2" data-id="element-324">|</span>
                    <span className="text-gray-400" data-id="element-325">{t.loc}</span>
                    <span className="text-gray-500 mx-2" data-id="element-326">|</span>
                    <span className="text-cyan text-xs" data-id="element-327">{t.plan}</span>
                  </div>
                </div>)}
            </div>
          </div>
        </FadeIn>

        {/* Guarantee */}
        <FadeIn delay={0.5} data-id="element-328">
          <div className="max-w-3xl mx-auto bg-surfaceLight/50 rounded-3xl p-8 md:p-12 border border-white/5 text-center" data-id="element-329">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-white/5 mb-6" data-id="element-330">
              <ShieldCheck className="w-8 h-8 text-white" data-id="element-331" />
            </div>
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-4" data-id="element-332">
              GARANTÍA 7 DÍAS — SIN PREGUNTAS
            </h3>
            <p className="text-gray-300 text-lg mb-6" data-id="element-333">
              Abrís los módulos. Los usás en la ruta o en tu taller. Si en 7
              días no es lo que esperabas:
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-4 mb-6 text-white font-medium" data-id="element-334">
              <div className="flex items-center justify-center gap-2" data-id="element-335">
                <span className="text-green-400" data-id="element-336">✅</span> Devolución del 100%
              </div>
              <div className="flex items-center justify-center gap-2" data-id="element-337">
                <span className="text-green-400" data-id="element-338">✅</span> Sin formularios, sin
                drama.
              </div>
            </div>
            <div className="inline-block bg-background px-4 py-2 rounded-lg border border-white/10 text-sm text-gray-400" data-id="element-339">
              Tasa de devoluciones: menos del 1%.
            </div>
          </div>
        </FadeIn>

        {/* FAQ */}
        <FadeIn delay={0.6} data-id="element-340">
          <div className="max-w-3xl mx-auto mt-24" data-id="element-341">
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-8 text-center" data-id="element-342">
              ❓ LO QUE MÁS NOS PREGUNTAN
            </h3>
            <div className="space-y-4" data-id="element-343">
              {[{
              q: '¿Sirve si no sé nada de mecánica?',
              a: 'Sí. El Protocolo Anti-Tirado fue diseñado específicamente para personas sin conocimientos técnicos. Cada paso está explicado en lenguaje simple, con tablas claras y decisiones de sí/no. No necesitás saber mecánica para seguir los 15 pasos o usar el mapa de decisión.'
            }, {
              q: '¿Sirve para cualquier tipo de moto?',
              a: 'Sí. El sistema está optimizado para motos 110/150cc — las más vendidas en Argentina — pero los protocolos de emergencia aplican a cualquier moto de uso urbano o de ruta.'
            }, {
              q: '¿Cómo recibo el material?',
              a: '100% digital. En menos de 5 minutos después del pago recibís acceso a todos los PDFs en tu email. Los descargás, los guardás en el celular y están disponibles sin internet cuando los necesitás.'
            }, {
              q: '¿Qué lo diferencia del material gratuito de YouTube?',
              a: 'YouTube te da información suelta. El Protocolo Anti-Tirado te da un sistema de decisión ordenado para usar en el momento exacto de la emergencia — cuando estás solo, de noche, en la calle y con el corazón acelerado. No es lo mismo saber mecánica que tener un protocolo claro bajo presión.'
            }, {
              q: '¿Tiene garantía real?',
              a: 'Sí. 7 días con devolución del 100% sin preguntas. Si no es lo que esperabas, escribís a soporteoficialfegion@gmail.com y en 24 horas tenés el reembolso.'
            }].map((faq, i) => <div key={i} className="bg-surfaceLight border border-white/5 rounded-xl overflow-hidden" data-id="element-344">
                  <button onClick={() => setOpenFaq(openFaq === i ? null : i)} className="w-full px-6 py-4 text-left flex items-center justify-between focus:outline-none" data-id="element-345">
                    <span className="font-medium text-white pr-4" data-id="element-346">{faq.q}</span>
                    <ChevronDown className={`w-5 h-5 text-gray-400 transition-transform shrink-0 ${openFaq === i ? 'rotate-180' : ''}`} data-id="element-347" />
                  </button>
                  {openFaq === i && <div className="px-6 pb-4 text-gray-400" data-id="element-348">{faq.a}</div>}
                </div>)}
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}